export class LocalStorageService {

  /**
   * 사용자 아이디
   */
  private USER_ID: string = 'userId';

  /**
   * 사용자 아이디 저장 여부
   */
  private REMEMBER_USER_ID: string = 'rememberUserId';

  /**
   * 인증 토큰
   */
  private AUTHORIZATION_TOKEN: string = 'crmAuthorizationToken';

  /**
   * 선택아동
   */
  private CHILD_NUM: string = 'childNum';

  /**
   * 탭 인덱스
   */
  private TAB_INDEX: string = 'tabIndex';

  /**
   * 튜토리얼 졸업 여부 스토리지 인덱스 명
   */
  private TUTORIAL_GRADUATE: string = 'isGraduatedTutorial';

  setUserId(id: string) {
    localStorage.setItem(this.USER_ID, id);
  }

  getUserId() {
    return localStorage.getItem(this.USER_ID);
  }

  removeUserId() {
    localStorage.removeItem(this.USER_ID);
  }

  setRememberUserId() {
    localStorage.setItem(this.REMEMBER_USER_ID, 'true');
  }

  getRememberUserId(): string {
    return localStorage.getItem(this.REMEMBER_USER_ID);
  }

  removeRememberUserId() {
    localStorage.removeItem(this.REMEMBER_USER_ID);
  }

  setAuthorizationToken(token: string) {
    localStorage.setItem(this.AUTHORIZATION_TOKEN, token);
  }

  getAuthorizationToken(): string {
    return localStorage.getItem(this.AUTHORIZATION_TOKEN);
  }

  removeAuthorizationToken() {
    localStorage.removeItem(this.AUTHORIZATION_TOKEN);
  }

  setChildNum(num: string) {
    localStorage.setItem(this.CHILD_NUM, num);
  }

  getChildNum(): string {
    return localStorage.getItem(this.CHILD_NUM);
  }

  removeChildNum() {
    localStorage.removeItem(this.CHILD_NUM);
  }

  setTabIndex(num: number | string) {
    localStorage.setItem(this.TAB_INDEX, num.toString());
  }

  getTabIndex(): string {
    return localStorage.getItem(this.TAB_INDEX);
  }

  removeTabIndex() {
    localStorage.removeItem(this.TAB_INDEX);
  }

  setTutorial() {
    localStorage.setItem(this.TUTORIAL_GRADUATE, 'true');
  }

  getTutorial(): string {
    return localStorage.getItem(this.TUTORIAL_GRADUATE);
  }

  removeTutorial() {
    localStorage.removeItem(this.TUTORIAL_GRADUATE);
  }
}
